export default {
  /**
   * Determines if the passed window object is an iframe
   * @param {Object} window The window object to assess
   * @return {Boolean}
   */
  active(window) {
    return window.self !== window.top;
  },

  /**
   * Returns the parent window if in an iframe, or the passed window if not
   * @param {Object} window The window object to assess
   * @return {Object}
   */
  getRoot(window) {
    if (this.active(window)) {
      try {
        // Check for permission to access window.top frame
        window.top.document;
        return window.top;
      } catch (error) {
        return window;
      }
    }

    return window;
  },

  /**
   * Updates the height ratio of the iframe when the content has changed
   * @param {Object} window The window object to assess
   */
  updateSize(window) {
    const href = window.location.href;
    const height = Math.max(
      window.document.documentElement.clientHeight,
      window.document.documentElement.offsetHeight,
      window.document.documentElement.scrollHeight,
      window.document.body.offsetHeight,
      window.document.body.scrollHeight
    );

    const iframes = window.parent.document.querySelectorAll(`iframe[src="${href}"]`);
    for (const iframe of iframes) {
      if (!iframe || !iframe.parentNode.classList.contains('sdc-video-embed')) {
        continue;
      }

      const ratio = (height / iframe.clientWidth) * 100;
      iframe.parentNode.style.paddingTop = `${ratio}%`;
    }
  }
};
